import { useState, useContext, useEffect } from 'react';
import { NavLink, useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import EnterkpiContainer from '../../../modules/enterkpi/containers/enterkpi.container';
import KpiMenuComponent from './kpi.menu.component';
import ProcessMenuComponent from './process-menu.component';
import { context as KpiContext } from '../../../context/kpi.context';
import { context as FilterContext } from '../../../context/filter.context';
import AlertsMenuComponent from './alerts.menu.component';
import AlertsComponent from '../../../modules/alerts/components/alerts.component';
import { setAlert } from '../../../redux/alerts/alert.action';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import FilterEquipmentsContainer from '../../../modules/filterequipments/containers/filter.equipments.container';
import { setSidebarClick } from '../../../redux/sidebar/sidebar.action';
import ExcelDownloadContainer from '../../../modules/exceldownload/containers/exceldownload.container';
import ReactGA from 'react-ga4';
import DownloadMenuComponent from './download.menu.component';
import { context as ProcessContext } from '../../../context/process.context';
import SelectMyDashboardMenu from './myDashboard.menu.component';
import SelectGraphContainer from '../../../modules/myDashboard/containers/select.graph.container';
import MyDashboardList from '../../../modules/myDashboard/component/myDashboardList.component';
import useHttpApiCall from '../../../services/useHttpApiCall';
import useDashboardRefresh from '../../../hooks/useDashboardRefresh'

export default function SidebarComponents() {
  const [openKpiSlider, setOpenKpiSlider] = useState(false);
  const [editKpiShow, setEditKpiShow] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [openSelectGraphSlider, setOpenSelectGraphSlider] = useState(false);
  const [editSelectGraphShow, setEditSelectGraphShow] = useState(false);
  const [openDashboardListSlider, setOpenDashboardListSlider] = useState(false);
  //const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [editPreviewShow, setEditPreviewShow]= useState(false);

  const {  isRefreshing } = useDashboardRefresh();

   const location = useLocation();
  // Condition to disable other menus

  const dispatch = useDispatch();
  const { trackEvent } = useMatomo();
  const [openAlertSlider, setOpenAlertSlider] = useState({
    select_source: false,
    active_alerts: false,
    set_alerts: false,
    alerts_screen: false
  });
  const [openFilterSlider, setOpenFilterSlider] = useState(false);
  const [, setLatestDashboardId] = useState(null);
  const [payload, setPayload] = useState(null);
  const [data] = useHttpApiCall(payload);

  useSelector((state) => state.equipmentAlert.combination_id);
  var fetchKpiLinks = useContext(KpiContext).fetchKpiLinks;
  let kpiSharedList = useContext(KpiContext).state.kpiLinks;
  var filterSharedList = useContext(FilterContext).state.filterChart;
  var kpiShareStateObject;
  const sidebarClick = useSelector((state) => state.sidebarClick.linkClick);
  const externalAccessEnabled = useSelector((state) => state.company.external_access_enabled);
  const flexibleEquipmentEnabled =
    localStorage.getItem('flexible_equipment') == 'true' ? true : false;
  const isOperator = localStorage.getItem('is_operator') == 'true' ? true : false;
  const company_layer = localStorage.getItem('company_layer') == 'true' ? true : false;
  let [searchParams] = useSearchParams();
  let parentPlantDetails = useContext(ProcessContext).state.sidebarLinks?.layers;
  const plant_id = searchParams.get('plant_id');
  const plant_code = searchParams.get('plant_code');
  const plant = searchParams.get('process');
const navigate = useNavigate();
  
  const [openDownloadSlider, setOpenDownloadSlider] = useState({
    select_source: false,
    set_download: false,
    download_screen: false
  });

  useEffect(() => {
    // More precise condition check
    const isViewDashboardList = location.pathname.includes('viewDashboardList');
    setEditPreviewShow(isViewDashboardList);
  }, [location.pathname]);

  const disableOtherMenus = openSelectGraphSlider || openDashboardListSlider || editPreviewShow;


  const [alertMenuClicked, setAlertMenuClicked] = useState(false);
  const resetStates = () => {
    setCheckedItems({});
    dispatch(setAlert(null));
  };

  const onSidebarClick = () => {
  
    if (!disableOtherMenus) {
      dispatch(setSidebarClick(!sidebarClick));
    }
  };

const handleMyDashboardClick = () => {
  setPayload({
    method: 'GET',
    auth: true,
    url: 'v0/my-dashboard/latest/'
  });
};

// when API response comes
useEffect(() => {
  if (data?.data?.data?.id) {
    const id = data.data.data.id;
    setLatestDashboardId(id);
    navigate(`/myDashboard/view/${id}`);
  }
}, [data?.data?.data]);


  useEffect(() => {
    if (kpiSharedList.openKpiScreen) {
      setOpenKpiSlider(true);
      if (kpiSharedList.editKpiShow) {
        setEditKpiShow(false);
      }
    }
  }, [kpiSharedList.openKpiScreen]);

  useEffect(() => {
    if (!openKpiSlider) {
      kpiShareStateObject = {
        openKpiScreen: false
      };
      fetchKpiLinks(kpiShareStateObject);
    }
  }, [openKpiSlider]);

  const openAlertScreen = (alertScreen) => {
    if (disableOtherMenus) return;
    
    if (alertScreen == 'set_alerts') {
      setOpenAlertSlider({
        select_source: false,
        active_alerts: false,
        set_alerts: true,
        alerts_screen: true
      });
    } else if (alertScreen == 'active_alerts') {
      setOpenAlertSlider({
        select_source: false,
        active_alerts: true,
        set_alerts: false,
        alerts_screen: true
      });
    } else if (alertScreen == 'close_slider') {
      resetStates();
      setOpenAlertSlider({
        select_source: false,
        active_alerts: false,
        set_alerts: false,
        alerts_screen: false
      });
    } else if (alertScreen == 'select_source') {
      setOpenAlertSlider({
        select_source: true,
        active_alerts: false,
        set_alerts: false,
        alerts_screen: true
      });
    }
  };

  const openDownloadScreen = (downloadScreen) => {
    if (disableOtherMenus) return;
    
    if (downloadScreen == 'set_download') {
      setOpenDownloadSlider({
        select_source: false,
        set_download: true,
        download_screen: true
      });
    } else if (downloadScreen == 'close_slider') {
      setOpenDownloadSlider({
        select_source: false,
        set_download: false,
        download_screen: false
      });
    } else if (downloadScreen == 'select_source') {
      setOpenDownloadSlider({
        select_source: true,
        set_download: false,
        download_screen: true
      });
    }
  };

  const onAlertSidebarClick = (item) => {
    if (disableOtherMenus) return;
    
    trackEvent({ category: 'Alert', action: 'Sidebar clicked' });
    ReactGA.event({
      category: 'Alert slider',
      action: 'Alert slider opened'
    });
    openAlertScreen(item);
    resetStates();
    setAlertMenuClicked((prev) => !prev);
    if (openDownloadSlider.download_screen) {
      openDownloadScreen('close_slider');
    }
  };

  const equipment_combination_id = useSelector((state) => state.equipmentAlert.combination_id);

  useEffect(() => {
    if (equipment_combination_id && !disableOtherMenus) {
      openAlertScreen('set_alerts');
    }
  }, [equipment_combination_id]);

  useEffect(() => {
    if (openKpiSlider && (openAlertSlider.alerts_screen || openDownloadSlider.download_screen)) {
      setOpenKpiSlider(false);
    }
  }, [openAlertSlider, openDownloadSlider]);

  useEffect(() => {
    if (filterSharedList != '' && !disableOtherMenus) {
      setOpenFilterSlider(true);
      if (openDownloadSlider.download_screen) {
        openDownloadScreen('close_slider');
      }
    } else {
      setOpenFilterSlider(false);
    }
  }, [filterSharedList]);
  
  const plantLayerLink = `/plant/${encodeURIComponent(
    plant || parentPlantDetails?.[0]?.name
  )}?process_type=plant&plant_id=${plant_id || parentPlantDetails?.[0]?.layer_id}&plant_code=${
    plant_code || parentPlantDetails?.[0]?.plant_code
  }`;
  const layersLink = `/layers/${
    plant || parentPlantDetails?.[0]?.name
  }?process_type=plant&plant_id=${plant_id || parentPlantDetails?.[0]?.layer_id}&plant_code=${
    plant_code || parentPlantDetails?.[0]?.plant_code
  }`;

  const navHomeLink =
    flexibleEquipmentEnabled? (company_layer ? '/company' : plantLayerLink) : '/home';

return (
  <div className="daz-sidebar">
    <div className="daz-sidebar_icons">

      {/* 1. Home */}
      <NavLink
        to={disableOtherMenus ? '#' : navHomeLink}
        className={({ isActive }) =>
          'daz-sidebar__iconwrap' +
          (isActive && !(openAlertSlider.alerts_screen || openDownloadSlider.download_screen)
            ? ' daz-sidebar__iconwrap--active'
            : '') +
          (disableOtherMenus ? ' daz-sidebar__iconwrap--disabled' : '')
        }
        onClick={onSidebarClick}
        style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <i className="medium material-icons notranslate">home</i>
        <span>Home</span>
      </NavLink>

      {/* 2. Layers */}
      <div className="position-relative daz-sidebar__hoverwrp" style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <NavLink
          to={disableOtherMenus ? '#' : `${
            flexibleEquipmentEnabled
              ? company_layer
                ? '/layers'
                : layersLink
              : '/processes'
          }`}
          className={({ isActive }) =>
            'daz-sidebar__iconwrap' +
            (isActive && !(openAlertSlider.alerts_screen || openDownloadSlider.download_screen)
              ? ' daz-sidebar__iconwrap--active'
              : '') +
            (disableOtherMenus ? ' daz-sidebar__iconwrap--disabled' : '')
          }>
          <i className="medium material-icons notranslate">account_tree</i>
          <span>{flexibleEquipmentEnabled? 'Layers' : 'Processes'}</span>
        </NavLink>
        {!disableOtherMenus && <ProcessMenuComponent />}
      </div>

      {/* 3. My Dashboard */}
   {/* 3. My Dashboard */}
{flexibleEquipmentEnabled && !isOperator && (
  <div className="position-relative daz-sidebar__hoverwrp">
    <NavLink
      to={disableOtherMenus ? '#' : '/myDashboard'} // base path for activation
      className={({ isActive }) =>
        'daz-sidebar__iconwrap' +
        (isActive ? ' daz-sidebar__iconwrap--active' : '') +
        (isRefreshing ? ' daz-sidebar__iconwrap--loading' : '')
      }
      onClick={(e) => {
        e.preventDefault(); // prevent default link nav
        handleMyDashboardClick(); // fetch latest dashboard and navigate programmatically
      }}
      style={{ whiteSpace: 'nowrap', pointerEvents: disableOtherMenus ? 'none' : 'auto'}}
    >
      <i className="medium material-icons notranslate">dashboard</i>
      <span>My Dashboard {isRefreshing ? '...' : ''}</span>
    </NavLink>

    <SelectMyDashboardMenu
      oapenSelectGraphSlider={openSelectGraphSlider}
      editSelectGraphShow={editSelectGraphShow}
      setOpenSelectGraphSlider={setOpenSelectGraphSlider}
      setEditSelectGraphShow={setEditSelectGraphShow}
      openAlertScreen={openAlertScreen}
      openDownloadScreen={openDownloadScreen}
      setOpenDashboardListSlider={setOpenDashboardListSlider}
    />
  </div>
)}


      {/* 4. Sensor add-ons */}
      <NavLink
        to={disableOtherMenus ? '#' : "/sensor-add-ons"}
        className={({ isActive }) =>
          'daz-sidebar__iconwrap' +
          (isActive && !(openAlertSlider.alerts_screen || openDownloadSlider.download_screen)
            ? ' daz-sidebar__iconwrap--active'
            : '') +
          (disableOtherMenus ? ' daz-sidebar__iconwrap--disabled' : '')
        }
        style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <i className="medium material-icons notranslate">equalizer</i>
        <span>
          Sensor <br /> add-ons
        </span>
      </NavLink>

      {/* 5. KPI */}
      <div className="position-relative daz-sidebar__hoverwrp" style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <NavLink
          to={disableOtherMenus ? '#' : `${
            flexibleEquipmentEnabled
              ? `/kpi?plant_code=${plant_code || parentPlantDetails?.[0]?.plant_code}`
              : `/kpi`
          }`}
          className={({ isActive }) =>
            'daz-sidebar__iconwrap' +
            (isActive && !(openAlertSlider.alerts_screen || openDownloadSlider.download_screen)
              ? ' daz-sidebar__iconwrap--active'
              : '') +
            (disableOtherMenus ? ' daz-sidebar__iconwrap--disabled' : '')
          }>
          <i className="medium material-icons notranslate">show_chart</i>
          <span>KPI</span>
        </NavLink>
        {!disableOtherMenus && (
          <KpiMenuComponent
            openKpiSlider={openKpiSlider}
            editKpiShow={editKpiShow}
            setOpenKpiSlider={setOpenKpiSlider}
            setEditKpiShow={setEditKpiShow}
            openAlertScreen={openAlertScreen}
            openDownloadScreen={openDownloadScreen}
          />
        )}
      </div>

      {/* 6. Alarm */}
      <div
        className={
          openAlertSlider.alerts_screen
            ? 'daz-sidebar__iconwrap daz-sidebar__hoverwrp daz-sidebar__iconwrap--active'
            : 'daz-sidebar__iconwrap daz-sidebar__hoverwrp '
        }
        style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <div onClick={() => !disableOtherMenus && onAlertSidebarClick('select_source')}>
          <i className="medium material-icons notranslate" style={{ fontSize: '52px' }}>
            notifications_none
          </i>
          <span>Alerts</span>
        </div>
        {!disableOtherMenus && <AlertsMenuComponent onAlertSidebarClick={onAlertSidebarClick} />}
      </div>

      {/* 7. Download */}
      <div
        className={
          openDownloadSlider.download_screen
            ? 'daz-sidebar__iconwrap daz-sidebar__hoverwrp daz-sidebar__iconwrap--active'
            : 'daz-sidebar__iconwrap daz-sidebar__hoverwrp '
        }
        style={{ pointerEvents: disableOtherMenus ? 'none' : 'auto', opacity: disableOtherMenus ? 0.5 : 1 }}>
        <div onClick={() => !disableOtherMenus && (externalAccessEnabled ? null : openDownloadScreen('select_source'))}>
          <i className="medium material-icons notranslate">cloud_download</i>
          <span>Download data</span>
        </div>
        {!disableOtherMenus && externalAccessEnabled && (
          <DownloadMenuComponent openDownloadScreen={openDownloadScreen} />
        )}
      </div>

      {/* 8. Reduction advice */}
      <div className="daz-sidebar__iconwrap daz-sidebar__iconwrap--disabled">
        <i className="medium material-icons notranslate">timeline</i>
        <span>Reduction advice</span>
      </div>
    </div>
 
          {/* <div className="position-relative daz-sidebar__hoverwrp">
          <NavLink
            to={`${flexibleEquipmentEnabled=='true'?`/kpi?plant_code=${plant_code||parentPlantDetails?.[0].plant_code}`:`/kpi`}`}
            // to="/kpi"
            className={({ isActive }) =>
              'daz-sidebar__iconwrap' +
              (isActive && !(openAlertSlider.alerts_screen || openDownloadSlider.download_screen)
                ? ' daz-sidebar__iconwrap--active'
                : '')
            }
          >
            <i className="medium material-icons notranslate">show_chart</i>
            <span>KPI</span>
          </NavLink>
          <KpiMenuComponent
            openKpiSlider={openKpiSlider}
            editKpiShow={editKpiShow}
            setOpenKpiSlider={setOpenKpiSlider}
            setEditKpiShow={setEditKpiShow}
            openAlertScreen={openAlertScreen}
            openDownloadScreen={openDownloadScreen}
          />
        </div> */}

      {openKpiSlider && (
        <EnterkpiContainer
          setOpenKpiSlider={setOpenKpiSlider}
          editKpiShow={editKpiShow}
          setEditKpiShow={setEditKpiShow}
        />
      )}
      
      {openAlertSlider.alerts_screen && (
        <AlertsComponent
          openAlertSlider={openAlertSlider}
          setOpenAlertSlider={setOpenAlertSlider}
          openAlertScreen={openAlertScreen}
          checkedItems={checkedItems}
          setCheckedItems={setCheckedItems}
          alertMenuClicked={alertMenuClicked}
        />
      )}
      
      {openDownloadSlider.download_screen && (
        <ExcelDownloadContainer
          openDownloadSlider={openDownloadSlider}
          openDownloadScreen={openDownloadScreen}
        />
      )}
      
      {openFilterSlider && <FilterEquipmentsContainer />}
      
      {openSelectGraphSlider && (
        <SelectGraphContainer
          setOpenSelectGraphSlider={setOpenSelectGraphSlider}
      
        />
      )}
      
      {openDashboardListSlider && (
        <MyDashboardList
          setOpenDashboardListSlider={setOpenDashboardListSlider}
          setOpenSelectGraphSlider={setOpenSelectGraphSlider}
     
        />
      )}
    </div>
  );
}
    